export default function getAbbreviatedNum(num: number, whole?: boolean): string {
  // return 5 digit numbers as local strings
  if (num < 1000) return num.toLocaleString();

  const numStr = String(num);
  const numStrArr = numStr.split('');
  const scaleChar =
    num < 1000000
      ? 'K'
      : num < 1000000000
      ? 'M'
      : num < 1000000000000
      ? 'B'
      : num < 1000000000000000
      ? 'T'
      : 'Q'; // numbers in quadrillions would require a refactor to use JS big int

  // return digits that don't need a "." in its presentation
  if (numStrArr.length % 3 === 0) {
    return numStr.slice(0, 3) + scaleChar;
  }

  // return number without "." if caller doesn't want them present
  if (whole) {
    return numStr.slice(0, numStr.length % 3) + scaleChar;
  }

  // starting from the back of the number add "." every 3rd number
  const numStrWithDelimiter = numStrArr
    .reverse()
    .map((x, i) => ((i + 1) % 3 === 0 ? `.${x}` : x))
    .reverse()
    .join('');

  return numStrWithDelimiter.slice(0, 4) + scaleChar;
}
